import userCacheService from '../api/userCacheService'
import restService from './restService'

export default {
  getOpen () {
    let user = userCacheService.getCurrentUser()
    return restService.execute('get', `v1/employees/${user.id}/timesheets/open`)
  },
  getAll (start, end) {
    let user = userCacheService.getCurrentUser()
    if (start !== undefined && end !== undefined) {
      return restService.execute('get', `v1/employees/${user.id}/timesheets/all?start=${start.toISOString()}&end=${end.toISOString()}`)
    }
    return restService.execute('get', `v1/employees/${user.id}/timesheets/all`)
  },
  getToBeApproved () {
    let user = userCacheService.getCurrentUser()
    return restService.execute('get', `v1/employees/${user.id}/timesheets/tobeapproved`)
  },
  getToBeProcessed () {
    let user = userCacheService.getCurrentUser()
    return restService.execute('get', `v1/employees/${user.id}/timesheets/tobeprocessed`)
  },
  get (timesheetId) {
    let user = userCacheService.getCurrentUser()
    return restService.execute('get', `v1/employees/${user.id}/timesheets/${timesheetId}`)
  },
  getReport (timesheetReportId) {
    let user = userCacheService.getCurrentUser()
    return restService.execute('get', `v1/employees/${user.id}/timesheetreports/${timesheetReportId}`)
  },
  download (timesheetId) {
    let user = userCacheService.getCurrentUser()
    return restService.execute('get', `v1/employees/${user.id}/timesheets/${timesheetId}/download`, null, true)
  },
  update (timesheetId, data) {
    let user = userCacheService.getCurrentUser()
    return restService.execute('put', `v1/employees/${user.id}/timesheets/${timesheetId}`, data)
  },
  approve (employeeId, timesheetId, comment) {
    let user = userCacheService.getCurrentUser()
    return restService.execute('put', `v1/employees/${employeeId}/timesheets/${timesheetId}/approve`, { id: user.id, comment: { detail: comment } })
  },
  reject (employeeId, timesheetId, comment) {
    let user = userCacheService.getCurrentUser()
    return restService.execute('put', `v1/employees/${employeeId}/timesheets/${timesheetId}/reject`, { id: user.id, comment: { detail: comment } })
  },
  submit (timesheetId, timesheet, comment) {
    let user = userCacheService.getCurrentUser()
    return restService.execute('put', `v1/employees/${user.id}/timesheets/${timesheetId}/submit`, { timesheet: timesheet, operation: { id: user.id, comment: { detail: comment } } })
  },
  adjust (employeeId, timesheetId, timesheet, comment) {
    let user = userCacheService.getCurrentUser()
    return restService.execute('put', `v1/employees/${employeeId}/timesheets/${timesheetId}/adjust`, { timesheet: timesheet, operation: { id: user.id, comment: { detail: comment } } })
  },
  process (employeeId, timesheetId, comment) {
    let user = userCacheService.getCurrentUser()
    return restService.execute('put', `v1/employees/${employeeId}/timesheets/${timesheetId}/process`, { id: user.id, comment: { detail: comment } })
  },
}
